import { TIMED_SEQUENCE_ACTION_TYPE } from '../actions/timedSequence.actions';

const initialState = {};

const timedSequenceSchema = (state = initialState, { type, payload }) => {
  switch (type) {
    case TIMED_SEQUENCE_ACTION_TYPE.GET_TIMED_SEQUENCE_SCHEMA:
      return payload || state;

    default:
      return state;
  }
};

export default timedSequenceSchema;
